<script setup lang="ts">
import { requiredValidator } from "@validators";
import { VForm } from "vuetify/components/VForm";

const props = defineProps<{ form: any }>();

const formRef = ref<InstanceType<typeof VForm>>();

defineExpose({
  validate: () => formRef.value?.validate(),
});
</script>

<template>
  <VForm ref="formRef">
    <VWindowItem>
      <div class="mb-6">Add name and description</div>
      <VRow>
        <VCol cols="12">
          <VTextField
            v-model="props.form.name"
            :rules="[requiredValidator]"
            label="Event Name"
            placeholder="Event Name"
          />
        </VCol>
        <VCol cols="12">
          <VTextarea
            v-model="props.form.description"
            label="Event Description"
            placeholder="Event Description"
          />
        </VCol>
        <VCol cols="12">
          <VTextField
            v-if="props.form.trackTickets"
            v-model="props.form.moreInfoUrl"
            label="More Info Link"
            hint="Full url eg https://moreInfo.com"
            persistent-hint
          />
        </VCol>
      </VRow>
    </VWindowItem>
  </VForm>
</template>
